import { gql } from "@apollo/client";

const GET_BRAND_MEMBERS = gql`
  query GetUserLookUp($params: GetUserParams!) {
    users(params: $params) {
      count
      items {
        userId
        fullName
        email
        firstName
        avatar
        isDeleted
        roles {
            roleName
            roleKey
        }
      }
    }
  }
`;

export default GET_BRAND_MEMBERS;
